/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Content_Real_TreeInputs */

const en_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Plant trees for the Earth </span>to reduce carbon </span>`)
};

const ar_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> <span style="[%2$s]">ازرع الأشجار من أجل الأرض </span> لتقليل انبعاثات الكربون </span>`)
};

const de_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Bäume pflanzen für die Erde </span>um Kohlenstoff zu reduzieren </span>`)
};

const es_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Planta árboles por la Tierra</span> para reducir las emisiones de carbono</span>`)
};

const fr_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Planter des arbres pour la Terre </span>pour y réduire le carbone </span>`)
};

const it_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Pianta alberi per la terra</span> per ridurre le emissioni</span>`)
};

const ja_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">地球のために本物の木を植樹</span>して二酸化炭素を削減</span>`)
};

const ko_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">탄소를 줄이기 위해 <span style="[%2$s]">나무를 심고 지구를 지키세요</span></span>`)
};

const pt_br_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Plante árvores pela Terra</span> para reduzir o carbono</span>`)
};

const ru_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Сажайте деревья для нашей Земли, </span>чтобы сократить выбросы углекислого газа </span>`)
};

const th_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">ปลูกต้นไม้ให้กับโลก</span>เพื่อลดคาร์บอน</span>`)
};

const tr_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Karbon ayak izini azaltmak için <span style="[%2$s]">dünyada gerçek ağaçlar</span> dik</span>`)
};

const zh_cn_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">为地球<span style="[%2$s]">种树减碳</span></span>`)
};

const zh_tw_subscription_walkthrough_p1_content_real_tree = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">為地球<span style="[%2$s]">種樹減碳</span></span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\"><span style=\"[%2$s]\">Plant trees for the Earth </span>to reduce carbon </span>" |
*
* @param {Subscription_Walkthrough_P1_Content_Real_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_content_real_tree = /** @type {((inputs?: Subscription_Walkthrough_P1_Content_Real_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Content_Real_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_content_real_tree(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_content_real_tree(inputs)
	return zh_tw_subscription_walkthrough_p1_content_real_tree(inputs)
});